<div class="responsive-container p-grid">
  <p-panel>
    <ng-template pTemplate="header">
      <div class="responsive-header">
        <div>
          <span class="responsive-header-title">
            Paletizar Artículos
            <p class="responsive-header-subtitle">{{ accountName }}</p>
          </span>
        </div>

        <div class="flex gap-2 align-items-center">
          <button pButton icon="pi pi-times" class="p-button-rounded p-button-text"
          (click)="onClose()"></button>
        </div>
      </div>
    </ng-template>

  <p-fluid>
    <div class="content">
      <!-- View Messages -->
      <p-toast [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }" />

      @if (!paletize) {
        <div class="articles_content">
          <!-- Manual Scanner -->
          <div class="field">
            <label for="manualQr">Código Etiqueta Simple</label>
            <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR"
              [(ngModel)]="manualQrCode" (input)="onManualInputChange()" />
          </div>
          <!-- Lista de artículos escaneados -->
          <div class="field">
            <ng-container *ngTemplateOutlet="tablaTemplate"></ng-container>
          </div>
          <!-- Botones de acción -->
          <div class="field">
            <p-button label="Siguiente" icon="pi pi-fast-forward" (click)="paletize=true"
            [disabled]="!scannedItems.length"></p-button>
          </div>
        </div>
      }

      <!-- Pallet Details-->
      @if (paletize) {
        <div class="pallet_content">
          <!-- Manual Palet Scanner -->
          @if (!palletCode) {
            <div class="field">
              <label for="manualQr">Código Etiqueta de Palet</label>
              <input id="manualCode" type="text" pInputText placeholder="Escanea el Código QR"
                [(ngModel)]="manualPaletQrCode" (input)="onManualPalletInputChange()" />
            </div>
          }
          @if (palletCode) {
            <div class="field">
              <p-chip [label]="palletCode" icon="" (onRemove)="resetPalletCode()"
                [removable]="true"><strong>Código Pallet: </strong></p-chip>
              </div>
            }
            <div class="field">
              <p-button (click)="openCamera()" label="Tomar foto de Palet" icon="pi pi-camera" [rounded]="true"
                severity="info" [outlined]="true" />
              <input type="file" id="cameraInput" accept="image/*" capture="environment"
                (change)="onPhotoSelected($event)" style="display:none;" multiple>
            </div>
            <div class="field">
              @if (selectedImages.length > 0) {
                @for (image of selectedImages; track image; let i = $index) {
                  <p-chip [label]="'Foto ' + (i+1)"
                    removable="true" (onRemove)="removeImage(i)" class="p-chip mb-1 ml-1"
                    styleClass="padding: 0 0.50rem;">
                    <img [src]="image" alt="Foto" style="width: 30px; height: 30px; margin-left: 2px;" />
                  </p-chip>
                }
              }
            </div>
            <!-- Lista de artículos escaneados -->
            <div class="field">
              <ng-container *ngTemplateOutlet="tablaTemplate"></ng-container>
            </div>
            <!-- Botones de acción -->
            <div class="field">
              <p-button label="Guardar" icon="pi pi-save" (click)="onSave()" [disabled]="!palletCode"></p-button>
            </div>
          </div>
        }
      </div>
    </p-fluid>
    </p-panel>
  </div>

  <ng-template #tablaTemplate>
    <p-table [value]="scannedItems" styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th>QR</th>
          <th>Descripción</th>
          <th>#</th>
          @if (!paletize) {
            <th></th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex" let-editing="editing">
        <tr>
          <td>{{ item.code }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.quantity }}</td>
          @if (!paletize) {
            <td>
              <p-button icon="pi pi-trash" severity="danger" [outlined]="true" (click)="removeItem(i)"></p-button>
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
  </ng-template>
  <p-confirmDialog></p-confirmDialog>